
    import { ProductVisualizer } from './src/index.ts';
    
    // Load config from demo assets
    async function init() {
      try {
        const response = await fetch('/assets/demo/config.json');
        const config = await response.json();
        
        const visualizer = new ProductVisualizer({
          container: '#visualizer',
          debug: true,
          standalone: true,
          standaloneConfig: {
            configId: 'demo',
            shop: 'demo',
            config,
            theme: {
              primaryColor: '#0d6efd',
              secondaryColor: '#6c757d',
              backgroundColor: '#ffffff',
              textColor: '#1f2937',
              accentColor: '#22c55e',
            },
            settings: {
              autoRotate: false,
              autoRotateSpeed: 2,
              enableZoom: true,
              enablePan: true,
              showControls: true,
              showFullscreenButton: true,
              showKeybinds: true,
              showViewSnaps: true,
              showFocusLock: true,
              enableSelection: false,
            },
          },
        });
        
        await visualizer.init();
        
        // Expose for debugging in console
        window.visualizer = visualizer;
        
      } catch (error) {
        console.error('Failed to initialize visualizer:', error);
        document.body.innerHTML = `
          <div style="color: white; padding: 20px; font-family: monospace;">
            <h2>Failed to load visualizer</h2>
            <pre>${error.message}</pre>
          </div>
        `;
      }
    }
    
    init();
  